export default fileUrl => {
  const loginEvent = new CustomEvent('avatarChanged', {
    detail: {
      fileUrl,
    }
  });
  document.dispatchEvent(loginEvent);
};
